"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#1F2229', 'dark-gray', 'Xám đen');
//# sourceMappingURL=dark-gray.js.map